export type Language = 'en' | 'uk' | 'fr'
export const translations = {
  en: {
    // App & Footer
    appTitle: 'AgileBrain Hub',
    appSubtitle: 'Create • Connect • Analyze',
    footerText: 'Conceptual Demo Q4 2025 • AgileBrain Hub',
    currentOrganization: 'Current Organization',
    // Navigation Sections
    sectionOperations: 'Operations',
    sectionContent: 'Content',
    sectionAdministration: 'Administration',
    // Navigation
    dashboard: 'Dashboard',
    organizationSetup: 'Organization Setup',
    rolesAndAccess: 'Roles & Access',
    tenantSetup: 'Organization Setup',
    taxonomy: 'Taxonomy',
    imageLibrary: 'Image Library',
    imageSets: 'Image Sets',
    exerciseAuthoring: 'Exercise Authoring',
    publishExercise: 'Publish Exercise',
    manageExercises: 'Manage Exercises',
    runnerPreview: 'Exercise Preview',
    results: 'Results',
    integrations: 'Integrations',
    analytics: 'Analytics',
    participantManagement: 'Participant Management',
    participantManagementSubtitle:
      'Manage participants across schools, grade groups, and classrooms',
    manageParticipantsAcross:
      'Manage participants across schools, grade groups, and classrooms',
    manageParticipantsTeams: 'Manage participants across teams and classes',
    addParticipants: 'Add Participants',
    participants: 'Participants',
    groups: 'Groups',
    schools: 'Schools',
    atRiskOnly: 'At-Risk Only',
    participant: 'Participant',
    externalId: 'External ID',
    group: 'Group',
    school: 'School',
    status: 'Status',
    assessments: 'Assessments',
    actions: 'Actions',
    noParticipantsFound: 'No participants found',
    adjustFilters: 'Try adjusting your filters or search query',
    searchParticipants: 'Search participants...',
    hideHierarchy: 'Hide Hierarchy',
    showHierarchy: 'Show Hierarchy',
    filteredParticipants: 'Filtered Participants',
    gradeGroups: 'Grade Groups',
    teamsClasses: 'Teams/Classes',
    atRiskFlagged: 'At-Risk Flagged',
    viewDetails: 'View Details',
    department: 'Department',
    assignmentManagement: 'Assignment Management',
    assignmentManagementSubtitle:
      'Assign exercises to organizational units using the hierarchy tree',
    organizationHierarchy: 'Organization Hierarchy',
    selectNodeToAssign: 'Select a node to assign exercises',
    assignExercise: 'Assign Exercise',
    assigningTo: 'Assigning to',
    selectExercise: 'Select Exercise',
    chooseExercise: 'Choose an exercise...',
    dueDate: 'Due Date',
    dueDateOptional: 'Due Date (Optional)',
    cancel: 'Cancel',
    assignedExercises: 'Assigned Exercises',
    all: 'All',
    assigned: 'Assigned',
    noAssignedExercises: 'No assigned exercises',
    noFilteredExercises: 'No exercises assigned to this node',
    selectFromHierarchy:
      'Select a node from the hierarchy tree to view and manage exercise assignments',
    // Dashboard
    dashboardSubtitle: "Overview of your organization's assessment activities",
    activeExercises: 'Active Exercises',
    totalParticipants: 'Total Participants',
    completions30d: 'Completions (30d)',
    atRiskParticipants: 'At-Risk Participants',
    cohorts: 'Cohorts',
    active: 'Active',
    flagged: 'Flagged',
    schoolsAcrossUkraine: 'Schools Across Ukraine',
    // LetGrow Efficacy
    programImpactEfficacy: 'Program Impact & Efficacy',
    programImpactDesc:
      'Measurable outcomes demonstrating the effectiveness of the LetGrow independence-building program',
    independenceGrowth: 'Independence Growth',
    independenceGrowthDesc: 'Average improvement in independence scores',
    resilienceIncrease: 'Resilience Increase',
    resilienceIncreaseDesc: 'Growth in resilience metrics over time',
    confidenceGain: 'Confidence Gain',
    confidenceGainDesc: 'Increase in self-confidence measures',
    parentSatisfaction: 'Parent Satisfaction',
    parentSatisfactionDesc: 'Parents reporting positive outcomes',
    // Quick Actions
    quickActions: 'Quick Actions',
    manageParticipants: 'Manage Participants',
    manageParticipantsDesc: 'Add, edit, or remove participants from cohorts',
    createAssignment: 'Create Assignment',
    createAssignmentDesc: 'Assign exercises to cohorts or individuals',
    createNewExercise: 'Create New Exercise',
    createNewExerciseDesc: 'Design and configure a new assessment exercise',
    buildImageSet: 'Build Image Set',
    buildImageSetDesc: 'Create and organize image collections for exercises',
    viewResults: 'View Results',
    viewResultsDesc: 'Analyze assessment outcomes and participant data',
    previewRunner: 'Preview Exercise',
    previewRunnerDesc: 'Test exercises before deployment',
    // Recent Activity
    recentActivity: 'Recent Activity',
    // Assignments
    activeAssignmentsOverview: 'Active Assignments Overview',
    activeAssignments: 'Active Assignments',
    totalAssigned: 'Total Assigned',
    completed: 'Completed',
    inProgress: 'In Progress',
    viewAll: 'View All',
    // Common
    settings: 'Settings',
    logout: 'Logout',
    switchRole: 'Switch Role',
    keyboardShortcuts: 'Keyboard Shortcuts',
    agilebrainAdmin: 'AgileBrain Admin',
    clientAdmin: 'Client Admin',
    skipToContent: 'Skip to content',
    create: 'Create Node',
    save: 'Save',
    // Access Control
    accessDenied: 'Access Denied',
    // Analytics Page
    analyticsDashboard: 'Analytics Dashboard',
    analyticsSubtitle:
      'Comprehensive assessment analytics with weighted positivity index',
    programEfficacySubtitle: 'Program efficacy and impact metrics',
    overview: 'Overview',
    efficacyReport: 'Efficacy Report',
    last30Days: 'Last 30 Days',
    last60Days: 'Last 60 Days',
    last90Days: 'Last 90 Days',
    allTime: 'All Time',
    loadingAnalytics: 'Loading analytics...',
    noDataAvailable: 'No Data Available',
    noDataMessage:
      'There are no completed assessments for the selected time period. Results will appear here once participants complete assessments.',
    viewAllTimeData: 'View All Time Data',
    totalAssessments: 'Total Assessments',
    completedInPeriod: 'Completed in selected period',
    avgPositiveAffect: 'Avg Positive Affect',
    meanPositivityScore: 'Mean positivity score',
    weightedPositivity: 'Weighted Positivity',
    accountsForWeight: 'Accounts for selection weight',
    atRiskRate: 'At-Risk Rate',
    participantsFlagged: 'participants flagged',
    programImpactMetrics: 'Program Impact Metrics',
    measurableOutcomes:
      'Measurable outcomes demonstrating program effectiveness',
    longitudinalProgress: 'Longitudinal Progress',
    studentDevelopment: 'Student development over time',
    dataCollected: 'Data collected from baseline through 6-month follow-up',
    timePeriod: 'Time Period',
    score: 'Score',
    independence: 'Independence',
    resilience: 'Resilience',
    confidence: 'Confidence',
    programReach: 'Program Reach',
    scaleAndDistribution: 'Scale and distribution',
    outcomes: 'Outcomes',
    successMetrics: 'Success metrics',
    totalStudents: 'Total Students',
    schoolsServed: 'Schools Served',
    activeCohorts: 'Active Cohorts',
    citiesReached: 'Cities Reached',
    completionRate: 'Completion Rate',
    positiveChange: 'Positive Change',
    sustainedImprovement: 'Sustained Improvement',
    teacherSatisfaction: 'Teacher Satisfaction',
    affectTrends: 'Affect Trends Over Time',
    monthlyAverages: 'Monthly average emotional state metrics',
    measuredScale: 'Positive and negative affect measured on 0-100 scale',
    month: 'Month',
    affectScore: 'Affect Score',
    positiveAffect: 'Positive Affect',
    negativeAffect: 'Negative Affect',
    weightedDistribution: 'Weighted Positivity Distribution',
    participantDistribution:
      'Participant distribution across positivity ranges',
    higherScores:
      'Higher scores indicate more positive emotional selection patterns',
    scoreRange: 'Score Range',
    participants: 'Participants',
    assessmentVolume: 'Assessment Volume by Month',
    totalCompleted: 'Total completed assessments over time',
    trackingEngagement: 'Tracking engagement and participation trends',
    completedAssessments: 'Completed Assessments',
    pre: 'Pre',
    post: 'Post',
  },
  uk: {
    // App & Footer
    appTitle: 'AgileBrain Hub',
    appSubtitle: 'Створюйте • Підключайте • Аналізуйте',
    footerText: 'Концептуальна демонстрація Q4 2025 • AgileBrain Hub',
    currentOrganization: 'Поточна організація',
    // Navigation Sections
    sectionOperations: 'Операції',
    sectionContent: 'Контент',
    sectionAdministration: 'Адміністрування',
    // Navigation
    dashboard: 'Панель управління',
    organizationSetup: 'Налаштування організації',
    rolesAndAccess: 'Ролі та Доступ',
    tenantSetup: 'Налаштування організації',
    taxonomy: 'Таксономія',
    imageLibrary: 'Бібліотека зображень',
    imageSets: 'Набори зображень',
    exerciseAuthoring: 'Створення вправи',
    publishExercise: 'Опублікувати вправу',
    manageExercises: 'Керувати вправами',
    runnerPreview: 'Попередній перегляд вправи',
    results: 'Результати',
    integrations: 'Інтеграції',
    analytics: 'Аналітика',
    participantManagement: 'Управління учасниками',
    participantManagementSubtitle:
      'Керуйте учасниками в школах, класах та кабінетах',
    manageParticipantsAcross:
      'Керуйте учасниками в школах, класах та кабінетах',
    manageParticipantsTeams: 'Керуйте учасниками в командах та класах',
    addParticipants: 'Додати учасників',
    participants: 'Учасники',
    groups: 'Групи',
    schools: 'Школи',
    atRiskOnly: 'Тільки групи ризику',
    participant: 'Учасник',
    externalId: 'Зовнішній ID',
    group: 'Група',
    school: 'Школа',
    status: 'Статус',
    assessments: 'Оцінювання',
    actions: 'Дії',
    noParticipantsFound: 'Учасників не знайдено',
    adjustFilters: 'Спробуйте налаштувати фільтри або пошуковий запит',
    searchParticipants: 'Пошук учасників...',
    hideHierarchy: 'Приховати ієрархію',
    showHierarchy: 'Показати ієрархію',
    filteredParticipants: 'Відфільтровані учасники',
    gradeGroups: 'Групи класів',
    teamsClasses: 'Команди/Класи',
    atRiskFlagged: 'Позначено групи ризику',
    viewDetails: 'Переглянути деталі',
    department: 'Відділ',
    assignmentManagement: 'Управління призначеннями',
    assignmentManagementSubtitle:
      'Призначайте вправи організаційним підрозділам за допомогою дерева ієрархії',
    organizationHierarchy: 'Ієрархія організації',
    selectNodeToAssign: 'Виберіть вузол для призначення вправ',
    assignExercise: 'Призначити вправу',
    assigningTo: 'Призначення для',
    selectExercise: 'Виберіть вправу',
    chooseExercise: 'Оберіть вправу...',
    dueDate: 'Термін виконання',
    dueDateOptional: "Термін виконання (необов'язково)",
    cancel: 'Скасувати',
    assignedExercises: 'Призначені вправи',
    all: 'Всі',
    assigned: 'Призначено',
    noAssignedExercises: 'Немає призначених вправ',
    noFilteredExercises: 'Немає вправ, призначених цьому вузлу',
    selectFromHierarchy:
      'Виберіть вузол з дерева ієрархії для перегляду та управління призначеннями вправ',
    dashboardSubtitle: 'Огляд діяльності організації з оцінювання',
    activeExercises: 'Активні вправи',
    totalParticipants: 'Всього учасників',
    completions30d: 'Завершення (30д)',
    atRiskParticipants: 'Учасники групи ризику',
    cohorts: 'Когорти',
    active: 'Активні',
    flagged: 'Позначено',
    schoolsAcrossUkraine: 'Школи по всій Україні',
    // LetGrow Efficacy
    programImpactEfficacy: 'Вплив та ефективність програми',
    programImpactDesc:
      'Вимірювані результати, що демонструють ефективність програми розвитку незалежності LetGrow',
    independenceGrowth: 'Зростання незалежності',
    independenceGrowthDesc: 'Середнє покращення показників незалежності',
    resilienceIncrease: 'Зростання стійкості',
    resilienceIncreaseDesc: 'Зростання показників стійкості з часом',
    confidenceGain: 'Зростання впевненості',
    confidenceGainDesc: 'Збільшення показників впевненості в собі',
    parentSatisfaction: 'Задоволеність батьків',
    parentSatisfactionDesc: 'Батьки, які повідомляють про позитивні результати',
    // Quick Actions
    quickActions: 'Швидкі дії',
    manageParticipants: 'Керувати учасниками',
    manageParticipantsDesc:
      'Додавати, редагувати або видаляти учасників з когорт',
    createAssignment: 'Створити призначення',
    createAssignmentDesc: 'Призначити вправи когортам або окремим особам',
    createNewExercise: 'Створити нову вправу',
    createNewExerciseDesc: 'Розробити та налаштувати нову вправу оцінювання',
    buildImageSet: 'Створити набір зображень',
    buildImageSetDesc: 'Створити та організувати колекції зображень для вправ',
    viewResults: 'Переглянути результати',
    viewResultsDesc: 'Аналізувати результати оцінювання та дані учасників',
    previewRunner: 'Попередній перегляд вправи',
    previewRunnerDesc: 'Тестувати вправи перед розгортанням',
    // Recent Activity
    recentActivity: 'Остання активність',
    // Assignments
    activeAssignmentsOverview: 'Огляд активних призначень',
    activeAssignments: 'Активні призначення',
    totalAssigned: 'Всього призначено',
    completed: 'Завершено',
    inProgress: 'В процесі',
    viewAll: 'Переглянути все',
    // Common
    settings: 'Налаштування',
    logout: 'Вийти',
    switchRole: 'Змінити роль',
    keyboardShortcuts: 'Клавіатурні скорочення',
    agilebrainAdmin: 'Адміністратор AgileBrain',
    clientAdmin: 'Адміністратор клієнта',
    skipToContent: 'Перейти до вмісту',
    create: 'Створити вузол',
    save: 'Зберегти',
    accessDenied: 'Доступ заборонено',
    // Analytics Page
    analyticsDashboard: 'Панель аналітики',
    analyticsSubtitle:
      'Комплексна аналітика оцінювання з зваженим індексом позитивності',
    programEfficacySubtitle: 'Показники ефективності та впливу програми',
    overview: 'Огляд',
    efficacyReport: 'Звіт про ефективність',
    last30Days: 'Останні 30 днів',
    last60Days: 'Останні 60 днів',
    last90Days: 'Останні 90 днів',
    allTime: 'Весь час',
    loadingAnalytics: 'Завантаження аналітики...',
    noDataAvailable: 'Дані відсутні',
    noDataMessage:
      "Немає завершених оцінювань за вибраний період. Результати з'являться тут після того, як учасники завершать оцінювання.",
    viewAllTimeData: 'Переглянути всі дані',
    totalAssessments: 'Всього оцінювань',
    completedInPeriod: 'Завершено за вибраний період',
    avgPositiveAffect: 'Сер. позитивний афект',
    meanPositivityScore: 'Середній показник позитивності',
    weightedPositivity: 'Зважена позитивність',
    accountsForWeight: 'Враховує вагу вибору',
    atRiskRate: 'Рівень ризику',
    participantsFlagged: 'учасників позначено',
    programImpactMetrics: 'Показники впливу програми',
    measurableOutcomes:
      'Вимірювані результати, що демонструють ефективність програми',
    longitudinalProgress: 'Поздовжній прогрес',
    studentDevelopment: 'Розвиток студентів з часом',
    dataCollected:
      'Дані зібрані від базової лінії до 6-місячного спостереження',
    timePeriod: 'Часовий період',
    score: 'Оцінка',
    independence: 'Незалежність',
    resilience: 'Стійкість',
    confidence: 'Впевненість',
    programReach: 'Охоплення програми',
    scaleAndDistribution: 'Масштаб та розподіл',
    outcomes: 'Результати',
    successMetrics: 'Показники успіху',
    totalStudents: 'Всього студентів',
    schoolsServed: 'Обслуговано шкіл',
    activeCohorts: 'Активні когорти',
    citiesReached: 'Охоплено міст',
    completionRate: 'Рівень завершення',
    positiveChange: 'Позитивні зміни',
    sustainedImprovement: 'Стійке покращення',
    teacherSatisfaction: 'Задоволеність вчителів',
    affectTrends: 'Тенденції афекту з часом',
    monthlyAverages: 'Середньомісячні показники емоційного стану',
    measuredScale: 'Позитивний та негативний афект вимірюється за шкалою 0-100',
    month: 'Місяць',
    affectScore: 'Оцінка афекту',
    positiveAffect: 'Позитивний афект',
    negativeAffect: 'Негативний афект',
    weightedDistribution: 'Розподіл зваженої позитивності',
    participantDistribution: 'Розподіл учасників за діапазонами позитивності',
    higherScores:
      'Вищі оцінки вказують на більш позитивні патерни емоційного вибору',
    scoreRange: 'Діапазон оцінок',
    participants: 'Учасники',
    assessmentVolume: 'Обсяг оцінювань за місяць',
    totalCompleted: 'Загальна кількість завершених оцінювань з часом',
    trackingEngagement: 'Відстеження залученості та участі',
    completedAssessments: 'Завершені оцінювання',
    pre: 'До',
    post: 'Після',
  },
  fr: {
    // App & Footer
    appTitle: 'AgileBrain Hub',
    appSubtitle: 'Créer • Connecter • Analyser',
    footerText: 'Démonstration conceptuelle Q4 2025 • AgileBrain Hub',
    currentOrganization: 'Organisation actuelle',
    // Navigation Sections
    sectionOperations: 'Opérations',
    sectionContent: 'Contenu',
    sectionAdministration: 'Administration',
    // Navigation
    dashboard: 'Tableau de bord',
    organizationSetup: "Configuration de l'organisation",
    rolesAndAccess: 'Rôles et Accès',
    tenantSetup: "Configuration de l'organisation",
    taxonomy: 'Taxonomie',
    imageLibrary: "Bibliothèque d'images",
    imageSets: "Ensembles d'images",
    exerciseAuthoring: "Création d'exercice",
    publishExercise: "Publier l'exercice",
    manageExercises: 'Gérer les exercices',
    runnerPreview: "Aperçu de l'exercice",
    results: 'Résultats',
    integrations: 'Intégrations',
    analytics: 'Analytique',
    participantManagement: 'Gestion des participants',
    participantManagementSubtitle:
      'Gérez les participants dans les écoles, les groupes de niveau et les salles de classe',
    manageParticipantsAcross:
      'Gérez les participants dans les écoles, les groupes de niveau et les salles de classe',
    manageParticipantsTeams:
      'Gérez les participants dans les équipes et les classes',
    addParticipants: 'Ajouter des participants',
    participants: 'Participants',
    groups: 'Groupes',
    schools: 'Écoles',
    atRiskOnly: 'À risque uniquement',
    participant: 'Participant',
    externalId: 'ID externe',
    group: 'Groupe',
    school: 'École',
    status: 'Statut',
    assessments: 'Évaluations',
    actions: 'Actions',
    noParticipantsFound: 'Aucun participant trouvé',
    adjustFilters:
      "Essayez d'ajuster vos filtres ou votre requête de recherche",
    searchParticipants: 'Rechercher des participants...',
    hideHierarchy: 'Masquer la hiérarchie',
    showHierarchy: 'Afficher la hiérarchie',
    filteredParticipants: 'Participants filtrés',
    gradeGroups: 'Groupes de niveau',
    teamsClasses: 'Équipes/Classes',
    atRiskFlagged: 'Signalé à risque',
    viewDetails: 'Voir les détails',
    department: 'Département',
    assignmentManagement: 'Gestion des affectations',
    assignmentManagementSubtitle:
      "Affectez des exercices aux unités organisationnelles à l'aide de l'arbre hiérarchique",
    organizationHierarchy: "Hiérarchie de l'organisation",
    selectNodeToAssign: 'Sélectionnez un nœud pour affecter des exercices',
    assignExercise: 'Affecter un exercice',
    assigningTo: 'Affectation à',
    selectExercise: 'Sélectionner un exercice',
    chooseExercise: 'Choisir un exercice...',
    dueDate: "Date d'échéance",
    dueDateOptional: "Date d'échéance (facultatif)",
    cancel: 'Annuler',
    assignedExercises: 'Exercices affectés',
    all: 'Tous',
    assigned: 'Affecté',
    noAssignedExercises: 'Aucun exercice affecté',
    noFilteredExercises: 'Aucun exercice affecté à ce nœud',
    selectFromHierarchy:
      "Sélectionnez un nœud dans l'arbre hiérarchique pour afficher et gérer les affectations d'exercices",
    dashboardSubtitle:
      "Aperçu des activités d'évaluation de votre organisation",
    activeExercises: 'Exercices actifs',
    totalParticipants: 'Total des participants',
    completions30d: 'Complétions (30j)',
    atRiskParticipants: 'Participants à risque',
    cohorts: 'Cohortes',
    active: 'Actif',
    flagged: 'Signalé',
    quickActions: 'Actions rapides',
    recentActivity: 'Activité récente',
    activeAssignmentsOverview: 'Aperçu des affectations actives',
    viewAll: 'Voir tout',
    settings: 'Paramètres',
    logout: 'Se déconnecter',
    switchRole: 'Changer de rôle',
    keyboardShortcuts: 'Raccourcis clavier',
    agilebrainAdmin: 'Administrateur AgileBrain',
    clientAdmin: 'Administrateur client',
    skipToContent: 'Passer au contenu',
    create: 'Créer un nœud',
    save: 'Enregistrer',
    accessDenied: 'Accès refusé',
    // Analytics Page
    analyticsDashboard: 'Tableau de bord analytique',
    analyticsSubtitle:
      'Analytique complète des évaluations avec indice de positivité pondéré',
    programEfficacySubtitle: 'Efficacité et impact du programme',
    overview: 'Aperçu',
    efficacyReport: "Rapport d'efficacité",
    last30Days: '30 derniers jours',
    last60Days: '60 derniers jours',
    last90Days: '90 derniers jours',
    allTime: 'Tout le temps',
    loadingAnalytics: 'Chargement des analyses...',
    noDataAvailable: 'Aucune donnée disponible',
    noDataMessage:
      "Il n'y a pas d'évaluations terminées pour la période sélectionnée. Les résultats apparaîtront ici une fois que les participants auront terminé les évaluations.",
    viewAllTimeData: 'Voir toutes les données',
    totalAssessments: 'Total des évaluations',
    completedInPeriod: 'Complété dans la période sélectionnée',
    avgPositiveAffect: 'Affect positif moyen',
    meanPositivityScore: 'Score de positivité moyen',
    weightedPositivity: 'Positivité pondérée',
    accountsForWeight: 'Tient compte du poids de sélection',
    atRiskRate: 'Taux à risque',
    participantsFlagged: 'participants signalés',
    programImpactMetrics: "Métriques d'impact du programme",
    measurableOutcomes:
      "Résultats mesurables démontrant l'efficacité du programme",
    longitudinalProgress: 'Progrès longitudinal',
    studentDevelopment: 'Développement des étudiants au fil du temps',
    dataCollected: 'Données collectées de la ligne de base au suivi de 6 mois',
    timePeriod: 'Période',
    score: 'Score',
    independence: 'Indépendance',
    resilience: 'Résilience',
    confidence: 'Confiance',
    programReach: 'Portée du programme',
    scaleAndDistribution: 'Échelle et distribution',
    outcomes: 'Résultats',
    successMetrics: 'Métriques de succès',
    totalStudents: 'Total des étudiants',
    schoolsServed: 'Écoles desservies',
    activeCohorts: 'Cohortes actives',
    citiesReached: 'Villes atteintes',
    completionRate: 'Taux de complétion',
    positiveChange: 'Changement positif',
    sustainedImprovement: 'Amélioration soutenue',
    teacherSatisfaction: 'Satisfaction des enseignants',
    affectTrends: "Tendances d'affect au fil du temps",
    monthlyAverages: "Moyennes mensuelles de l'état émotionnel",
    measuredScale: 'Affect positif et négatif mesuré sur une échelle de 0-100',
    month: 'Mois',
    affectScore: "Score d'affect",
    positiveAffect: 'Affect positif',
    negativeAffect: 'Affect négatif',
    weightedDistribution: 'Distribution de positivité pondérée',
    participantDistribution:
      'Distribution des participants par plages de positivité',
    higherScores:
      'Des scores plus élevés indiquent des modèles de sélection émotionnelle plus positifs',
    scoreRange: 'Plage de scores',
    participants: 'Participants',
    assessmentVolume: "Volume d'évaluations par mois",
    totalCompleted: 'Total des évaluations terminées au fil du temps',
    trackingEngagement:
      "Suivi de l'engagement et des tendances de participation",
    completedAssessments: 'Évaluations terminées',
    pre: 'Avant',
    post: 'Après',
  },
}
export function useTranslations(language: Language) {
  return translations[language]
}
